import React, {
  useContext as useReactContext,
  useState,
  Dispatch,
  SetStateAction,
  FC,
} from 'react';

export const createContext = <T,>(defaultValue: T) => {
  const context = React.createContext<T>(defaultValue);
  const useContext = () => useReactContext(context);

  return { ...context, useContext };
};

export type StateProps<T> = [T, Dispatch<SetStateAction<T>>];

export const createStateContext = <T,>(defaultValue: T) => {
  const { Provider: DefaultProvider, useContext } = createContext<StateProps<T>>([
    defaultValue,
    () => {
      // do nothing.
    },
  ]);

  const Provider: FC = ({ children }) => {
    const state = useState<T>(defaultValue);

    return <DefaultProvider value={state}>{children}</DefaultProvider>;
  };

  return { Provider, useContext };
};
